import { LOCATION_HISTORY_PATH_TYPES } from '../constants';

import { NavigationHistoryPathType } from '../types';

export const getNavigationHistoryIconColor = (value: NavigationHistoryPathType) => ({
  [LOCATION_HISTORY_PATH_TYPES.tracked]: '#50BC46',
  [LOCATION_HISTORY_PATH_TYPES.untracked]: '#F64F31',
  [LOCATION_HISTORY_PATH_TYPES.parking]: '#3B82F6'
}[value] || '#50BC46');
